import * as React from 'react'
import EmptyImage from './images/EmptyImage'
import { ZoomableGallery } from './images/SortableList'

export enum PictureSize {
  SOURCE = 'source',
  '100x100' = '100x100',
  '600x600' = '600x600'
}

export interface Picture {
  rank: number
  url: string
}

export interface PictureProps {
  rank: number
  pictures: { [key in PictureSize]?: Picture[] }
  size: PictureSize
  style?: React.CSSProperties
  onError?: (event) => void
  showImagesGallery?: boolean
}

const Picture: React.FC<PictureProps> = props => {
  const [errorHandled, setErrorHandled] = React.useState(false)
  const [currentImageIndex, setCurrentImageIndex] = React.useState(undefined)
  const { pictures, size, rank = 0, style, showImagesGallery = false } = props
  const images = pictures[size]

  if (!images.length) {
    return (
      <div style={style}>
        <EmptyImage />
      </div>
    )
  }

  const pic = images[rank]
  const fallback = pictures[PictureSize['600x600']][rank]

  if (!pic.url) {
    return (
      <div style={style}>
        <EmptyImage />
      </div>
    )
  }

  const handleError = (event: React.ChangeEvent<HTMLImageElement>) => {
    // when errorHandled is true prevent an infinite retry loop by returning early
    if (errorHandled) return
    setErrorHandled(true)

    // Custom error handling behavior if present
    if (props.onError) {
      props.onError(event)
      return
    }

    // default behavior is to try to use the fallback image url
    if (fallback.url) {
      event.target.src = fallback.url // eslint-disable-line no-param-reassign
    }
  }

  return (
    <>
      {showImagesGallery && (
        <ZoomableGallery
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
          items={pictures['600x600']}
        />
      )}
      <img
        onError={handleError}
        alt="Thumbnail"
        src={pic.url}
        className="table-thumbnail"
        style={{ ...style, borderRadius: 2 }}
        onClick={() => setCurrentImageIndex(rank)}
      />
    </>
  )
}

export default Picture
